import { convertValueToLocale } from "helpers/convertValueToLocale";

const RATES_KEY = {
  positive: "interestRateSpecialPositive",
  neutral: "interestRateSpecialNeutral",
  negative: "interestRateSpecialNegative",
};

const AMOUNTS_KEY = {
  positive: "specialLoanAmountPositive",
  neutral: "specialLoanAmountNeutral",
  negative: "specialLoanAmountNegative",
};

export const getSupportsData = (
  conclusionsPro: any,
  activePosition: 10 | 20 | 30
) => {
  const supportData = conclusionsPro?.baseCalculation ?? {};

  const userScenarioResult = conclusionsPro?.userScenarioResult;

  const specialRates = conclusionsPro?.loanConclusions ?? {};

  const ratesKey = RATES_KEY[userScenarioResult];
  const amountsKey = AMOUNTS_KEY[userScenarioResult];

  let rawRateValue: unknown = undefined;
  let rawAmountValue: unknown = undefined;
  let actualRates = "";
  let actualAmounts = "";

  try {
    const ratesContainer = specialRates[ratesKey];

    if (ratesContainer != null) {
      rawRateValue =
        ratesContainer[activePosition] ??
        ratesContainer[String(activePosition)] ??
        ratesContainer[Number(activePosition)];
    }
  } catch (err) {
    rawRateValue = undefined;
  }

  try {
    rawAmountValue = specialRates[amountsKey] ?? undefined;
  } catch (err) {
    rawAmountValue = undefined;
  }

  try {
    if (rawRateValue != null && rawRateValue !== "") {
      actualRates = convertValueToLocale(rawRateValue as any, 2, "");
    }
  } catch (err) {
    actualRates = "";
  }

  try {
    if (rawAmountValue != null && rawAmountValue !== "") {
      actualAmounts = convertValueToLocale(rawAmountValue as any);
    }
  } catch (err) {
    actualAmounts = "";
  }

  return { supportData, actualRates, actualAmounts };
};
